import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InitialConfig, SysIAccionesMonitoreo, SysIAnalitosResulTipoListas } from '../../types/types.config';
import { User } from '../../types/types.user';
// Define the initial state using that type
const initialState: InitialConfig = {
  Loading: true,
  IsAuthenticated: false,
  Error: null,
  Data: null,
  HeightPanels: 190,
  IsEditing: false,
  LstAnalitosResulTipoListas: [],
  LstAccionesMonitoreo: [],
  LstUsuarios: [],
  ModalBarcodePrintersVisible: false,
};

export const configSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    set: (state) => {},
    setLoadingCnf: (state, action: PayloadAction<boolean>) => {
      state.Loading = action.payload;
    },
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.IsAuthenticated = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.Error = action.payload;
      state.Data = null;
      state.Loading = false;
    },
    get: (state, action: PayloadAction<InitialConfig>) => {
      return action.payload;
    },
    setHeightPanels: (state, action: PayloadAction<number>) => {
      state.HeightPanels = action.payload;
    },
    setEditingMode: (state, action: PayloadAction<boolean>) => {
      state.IsEditing = action.payload;
    },
    setLstAnalitosResulTipoListas: (state, action: PayloadAction<SysIAnalitosResulTipoListas[]>) => {
      state.LstAnalitosResulTipoListas = action.payload;
    },
    setLstAccionesMonitoreo: (state, action: PayloadAction<SysIAccionesMonitoreo[]>) => {
      state.LstAccionesMonitoreo = action.payload;
    },
    setLstUsuarios: (state, action: PayloadAction<User[]>) => {
      state.LstUsuarios = action.payload;
    },
    setModalBarcodePrintersVisible: (state, action: PayloadAction<boolean>) => {
      state.ModalBarcodePrintersVisible = action.payload;
    },
  },
});

export const { set, setError, get, setIsAuthenticated, setLoadingCnf, setHeightPanels, setEditingMode, setLstAnalitosResulTipoListas, setLstAccionesMonitoreo, setLstUsuarios, setModalBarcodePrintersVisible } = configSlice.actions;
